import App from './App.vue'
import Vue from 'vue'
import { mount } from '../../lib/mount'
import { loadPolyfills } from '../../polyfills'
import { rootClassName } from './config'
import './App.css'
import globalEventStore from '../../lib/global-event-store'

mount(rootClassName, init, loadPolyfills)

function init(el, { sendGaEvent, sendError }) {
  const preloadedState = JSON.parse(el.getAttribute('data-preloaded-state'))
  globalEventStore.add(el.id, 'sendGaEvent', sendGaEvent)
  globalEventStore.add(el.id, 'sendError', sendError)

  const app = new Vue({
    render: h => h(App),
    data: {
      id: el.id,
      props: { ...preloadedState }
    }
  })

  app.$mount(el)
}
